import { AbstractControl } from '@angular/forms';

export const passwordValidator = (control: AbstractControl): { [key: string]: boolean } => {
    if (control.get('newPasswordRequired').value == null || control.get('newPasswordRequired').value === false) {
      return null;
    }

    if (control.get('password').value === null) {
      return { '': true };
    }

    if (control.get('password').value.length < 6) {
      return { 'passwordToShort': true };
    }

    return control.get('password').value === control.get('passwordConfirm').value
      ? null : { 'mismatch': true };
  };
